// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function PhoneCallBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M18.551 4.612a1.5 1.5 0 0 1 1.837-1.06 11.265 11.265 0 0 1 8.06 8.06 1.5 1.5 0 1 1-2.897.775 8.303 8.303 0 0 0-5.938-5.938 1.5 1.5 0 0 1-1.062-1.837Zm10.93 17.335A7.534 7.534 0 0 1 22 28.5C11.799 28.5 3.5 20.201 3.5 10a7.534 7.534 0 0 1 6.553-7.481A2.506 2.506 0 0 1 12.65 4l2.639 5.891a2.5 2.5 0 0 1-.197 2.376c-.033.05-.068.099-.107.144l-2.383 2.839c.883 1.605 2.563 3.27 4.187 4.151l2.788-2.375c.045-.037.092-.072.14-.105a2.49 2.49 0 0 1 2.376-.217l.022.01L28 19.35a2.508 2.508 0 0 1 1.481 2.598Zm-3.039-.007-5.25-2.351-2.803 2.384c-.044.038-.09.073-.139.106a2.5 2.5 0 0 1-2.461.171c-2.435-1.175-4.861-3.585-6.039-6a2.5 2.5 0 0 1 .16-2.455c.033-.05.069-.098.107-.144l2.396-2.84-2.353-5.25A4.536 4.536 0 0 0 6.5 10 15.52 15.52 0 0 0 22 25.5a4.535 4.535 0 0 0 4.442-3.56Zm-8.238-10.756a4 4 0 0 1 2.612 2.612 1.5 1.5 0 0 0 2.861-.893 7 7 0 0 0-4.573-4.574 1.5 1.5 0 1 0-.9 2.861v-.006Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
